import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import { ErrorBoundary } from '@pearsontechnology/aero-components';

import helpContext from 'constants/helpContext';
import CohortsPage from 'Workspace/Cohorts/components/CohortsPage';
import CohortEnrollments from 'Workspace/Cohorts/components/CohortEnrollments';
import CohortCourseware from 'Workspace/Cohorts/components/CohortCourseware';
import CohortGrades from 'Workspace/Cohorts/components/CohortGrades';
import CohortSettings from 'Workspace/Cohorts/components/CohortSettings';
import HelpMenu from 'Workspace/components/WorkspaceHelpMenu';
import ManualGradingReviewContainer from './components/CohortGrades/ManualGradingReviewContainer';

const Cohorts = () => (
  <ErrorBoundary>
    <React.Fragment>
      <Switch>
        <Route path="/classes/:cohortId/enrollments" component={CohortEnrollments} />
        <Route path="/classes/:cohortId/courseware" component={CohortCourseware} />
        <Route path="/classes/:cohortId/settings" component={CohortSettings} />

        <Route path="/classes/:cohortId/grades/:deploymentId" component={CohortGrades} />
        <Route path="/classes/:cohortId/grades" component={CohortGrades} />

        <Route
          path="/classes/:cohortId/review/:deploymentId/:interactiveId/:componentId/:studentId"
          render={({ match }) => (
            <ManualGradingReviewContainer {...match.params} />)}
        />

        <Route
          path="/classes/:cohortId/"
          render={({ match }) => (
            <Redirect to={`/classes/${match.params.cohortId}/courseware`} />
          )}
        />
        <Route exact path="/classes" component={CohortsPage} />
        <Redirect to="/classes" />
      </Switch>
      <HelpMenu helpContext={helpContext.CLASSES} />
    </React.Fragment>
  </ErrorBoundary>
);

export default Cohorts;
